import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useStore } from '../../zustand';
import ViewSpaceBtn from './ViewSpaceBtn'; // Rename to desktop Launch Button
// Helpers
import { sendAnalyticsData } from "../../utility/handleAnalytics";
import { setARCartURL, _setCustomBannerURL, setSessionID } from "../../utility/helpers";
// Icons
import ARicon from '../../assets/icons/ar_logo.svg';
import Rotate360 from "../../assets/icons/rotate360.svg";
import { ReactComponent as ARLogo } from '../../assets/icons/ar_logo.svg';
// Styles
import { arBtnStyles } from "../../assets/jss/arBtnStyles";
const useStyles = makeStyles(arBtnStyles);
// Variables
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;


export default function ARLaunch(props) {
    const { intent } = useStore.getState().hrx;
    
    return (
        <>
        { ((intent === 'willQL') || (intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV')) &&
            <MobileAR {...props} />
        }
        { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === 'cant')) &&
            <ViewSpaceBtn {...props} /> // Rename to desktop Launch Button
        }
        </>
    );
}

export const MobileAR = (props) => {
    const variant_id = useStore(state => state.variant_id);
    const { intent, target } = useStore.getState().hrx;
    const { ar_activation } = useStore.getState().settings;

    if (target === 'iPadQL' || target === 'iPadNQL' || target === 'iPadLiteNQL') {
        // window.parent.postMessage('iPadExit', '*');
        // return <IOSLaunch variant_id={variant_id} />
    } else if (intent === 'canQL' || intent === 'canSV') { // Redirect Modal
        return <ModalLaunchBtn modal_type={"Redirect"} design={props.design} />
    } else if(ar_activation && intent === 'willQL') { // Hank Redirect to Launch
        return <ModalLaunchBtn modal_type={"Hank"} design={props.design} />
    } else if(intent === 'willQL') { // IOS
        switch(props.design) {
            // case "normal":
            //     return <IOSLaunchBtnNormal variant_id={variant_id} />
            case "rotate_icon":
                return <IOSLaunchBtnRotate variant_id={variant_id} />
            case "billboard":
                return <IOSLaunchBtnBillboard variant_id={variant_id} />
            default:
                return <div></div>
                // return <IOSLaunchBtnNormal variant_id={variant_id} />
        }
    } else if(intent === 'willSV') { // Android
        return <AndroidLaunchBtn variant_id={variant_id} design={props.design} />
    } else {
        return <div></div> // Dont show anything
    }
}

// IOS BUTTON TYPES
// const IOSLaunchBtnNormal = (props) => {
//     const { store_id, vList } = useStore.getState().variants_payload;
//     const { variant_type } = useStore.getState().settings;
//     const actions = useStore(state => state.actions);
//     const { dynamic_text_settings } = useStore.getState().store_settings;
//     const classes = useStyles(dynamic_text_settings);
//     const { ar_experience } = useStore.getState().store_settings;
//     const anchor_tag = React.useRef(null)

//     React.useEffect(() => {
//         if(ar_experience?.ar_cta_status) {
//             anchor_tag.current.addEventListener("message", async function (event) {
//                 // eslint-disable-next-line
//                 if (event.data == "_apple_ar_quicklook_button_tapped") {
//                     actions.setFullScreenLoading(true)
//                     const qlBannerLink = setARCartURL(props.variant_id, vList, variant_type, ar_experience.ar_cta_type)
//                     await sendAnalyticsData({ event_type: 'cart_ar_add' });
                    
//                     setTimeout(() => {
//                         actions.setFullScreenLoading(false)
//                     }, 3000)
//                     window.location.assign(qlBannerLink);
//                 }
//             }, false);
//         }
//     }, [actions, props, vList, variant_type, ar_experience])

//     const _generateLink = () => {
//         const dt = `${BUCKET_URL}${store_id}/${vList[props.variant_id].bundle}/${vList[props.variant_id].ardt}.usdz`;
//         const scalingOn = '#allowsContentScaling=0';
//         const custom_cta = ar_experience?.ar_cta_status ? _setCustomBannerURL(props.variant_id, variant_type) : "";   
//         const quickLookURL = `${dt}${scalingOn}${custom_cta}`;
//         return quickLookURL;
//     }

//     return (
//         <div className={classes.button_container_default}>
//             <a rel="ar"
//             ref={anchor_tag} 
//             id={`quicklook_link_${setSessionID()}`}
//             href={_generateLink()}>
//                 <img src={ARicon} alt="AR" className={classes.button_ar_default} />
//                 <span className={classes.ar_text}>{dynamic_text_settings.mobile_ar_button.button_text}</span>
//             </a>
//         </div>
//     )
// }

const IOSLaunchBtnRotate = (props) => {
    const { store_id, vList } = useStore.getState().variants_payload;
    const { variant_type } = useStore.getState().settings;
    const actions = useStore(state => state.actions);
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    const { ar_experience } = useStore.getState().store_settings;
    const anchor_tag = React.useRef(null)

    React.useEffect(() => {
        if(ar_experience?.ar_cta_status) {
            anchor_tag.current.addEventListener("message", async function (event) {
                // eslint-disable-next-line
                if (event.data == "_apple_ar_quicklook_button_tapped") {
                    actions.setFullScreenLoading(true)
                    const qlBannerLink = setARCartURL(props.variant_id, vList, variant_type, ar_experience.ar_cta_type);
                    await sendAnalyticsData({ event_type: 'cart_ar_add' });
                    
                    setTimeout(() => {
                        actions.setFullScreenLoading(false)
                    }, 3000)
                    window.location.assign(qlBannerLink);
                }
            }, false);
        }
    }, [actions, props, vList, variant_type, ar_experience])

    const _generateLink = () => {
        const dt = `${BUCKET_URL}${store_id}/${vList[props.variant_id].bundle}/${vList[props.variant_id].ardt}.usdz`;
        const scalingOn = '#allowsContentScaling=0';
        const custom_cta = ar_experience?.ar_cta_status ? _setCustomBannerURL(props.variant_id, variant_type) : "";
        const quickLookURL = `${dt}${scalingOn}${custom_cta}`;
        return quickLookURL;
    }

    return (
        <div className={classes.iconContainer}>
            <a rel="ar"
               ref={anchor_tag} 
               id={`quicklook_link_${setSessionID()}`}
               href={_generateLink()}>
                <img src={Rotate360} alt="AR" className={classes.button_ar_rotate} />
            </a>
        </div>
    )
}

const IOSLaunchBtnBillboard = (props) => {
    const { store_id, vList } = useStore.getState().variants_payload;
    const { variant_type } = useStore.getState().settings;
    const actions = useStore(state => state.actions);
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    const { ar_experience } = useStore.getState().store_settings;
    const anchor_tag = React.useRef(null)

    React.useEffect(() => {
        if(ar_experience?.ar_cta_status) {
            anchor_tag.current.addEventListener("message", async function (event) {
                // eslint-disable-next-line
                if (event.data == "_apple_ar_quicklook_button_tapped") {
                    actions.setFullScreenLoading(true)
                    const qlBannerLink = setARCartURL(props.variant_id, vList, variant_type, ar_experience.ar_cta_type);
                    await sendAnalyticsData({ event_type: 'cart_ar_add' });
                    
                    setTimeout(() => {
                        actions.setFullScreenLoading(false)
                    }, 3000)
                    window.location.assign(qlBannerLink);
                }
            }, false);
        }
    }, [actions, props, vList, variant_type, ar_experience])

    const _generateLink = () => {
        const dt = `${BUCKET_URL}${store_id}/${vList[props.variant_id].bundle}/${vList[props.variant_id].ardt}.usdz`;
        const scalingOn = '#allowsContentScaling=0';
        const custom_cta = ar_experience?.ar_cta_status ? _setCustomBannerURL(props.variant_id, variant_type) : "";
        const quickLookURL = `${dt}${scalingOn}${custom_cta}`;
        return quickLookURL;
    }

    return (
        <div className={classes.button_container_billboard}>
            <a rel="ar"
            ref={anchor_tag}
            id={`quicklook_link_${setSessionID()}`}
            href={_generateLink()}>
                <img src={ARicon} alt="AR" className={classes.button_ar_icon_billboard} />
                <span>{dynamic_text_settings.mobile_ar_button.button_text}</span>
            </a>
        </div>
    )
}

const AndroidLaunchBtn = (props) => {
    const { store_id, vList } = useStore.getState().variants_payload;
    const { variant_type } = useStore.getState().settings;
    const { ar_experience } = useStore.getState().store_settings;
    const anchor_tag = React.useRef(null);

    const _generateLink = () => {
        const levar_intent = "ar_preferred" // Intent
        const fallback_url = "https://developers.google.com/ar;" // if Google Play Services for AR isn't present, Scene Viewer launches the URL you set in the
        const dt = `${BUCKET_URL}${store_id}/${vList[props.variant_id].bundle}/${vList[props.variant_id].ardt}.glb`; // GLB URL
        const title = vList[props.variant_id].title;
        const qlBannerLink = ar_experience?.ar_cta_status ? setARCartURL(props.variant_id, vList, variant_type, ar_experience.ar_cta_type) : setARCartURL(props.variant_id, vList, variant_type);

        // TODO How to send analytics if clicked on link to go back
        const sceneViewerUrl = `#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${fallback_url}`
        const finalUrl = `intent://arvr.google.com/scene-viewer/1.1?file=${dt}&title=${title}&link=${qlBannerLink}&mode=${levar_intent}&resizable=false${sceneViewerUrl}end;`; // v 1.1                        
        return finalUrl;
    }
    
    return (
        <BtnDesign
            _generateLink={_generateLink} 
            design={props.design} 
            ref={anchor_tag} 
        />
    );
}

const BtnDesign = React.forwardRef((props, ref) => {
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);

    switch(props.design) {
        case 'normal':
            return (
                <div className={classes.button_container_default}>
                    <a rel="ar"
                       ref={ref} 
                       id={`quicklook_link_${setSessionID()}`}
                       href={props._generateLink()}>
                        <img src={ARicon} alt="AR" className={classes.button_ar_default} />
                        <span className={classes.ar_text}>{dynamic_text_settings.mobile_ar_button.button_text}</span>
                    </a>
                </div>
            );
        case 'rotate_icon':
            return (
                <div className={classes.iconContainer}>
                    <a rel="ar"
                       ref={ref} 
                       id={`quicklook_link_${setSessionID()}`}
                       href={props._generateLink()}>
                        <img src={Rotate360} alt="AR" className={classes.button_ar_rotate} />
                    </a>
                </div>
            );
        case 'billboard':
            return (
                <div className={classes.button_container_billboard}>
                    <a rel="ar"
                       ref={ref}
                       id={`quicklook_link_${setSessionID()}`}
                       href={props._generateLink()}>
                        <ARLogo className={classes.button_ar_icon_billboard} />
                        <span>{dynamic_text_settings.mobile_ar_button.button_text}</span>
                    </a>
                </div>
            );
        case 'tabs':
            return (
                <div className={classes.button_container_tabs}>
                    <a rel="ar"
                       ref={ref}
                       id={`quicklook_link_${setSessionID()}`}
                       href={props._generateLink()}>
                        <span>My Space</span>
                        <div className={classes.tabs_icon_container}>
                            <ARLogo className={classes.button_ar_tabs} />
                        </div>
                    </a>
                </div>
            );
        default: 
            return (
                <div></div>
            )
    }
})

const ModalLaunchBtn = (props) => {
    const actions = useStore(state => state.actions);

    const _handleLaunchAR = async (e) => {
        e.preventDefault();
        
        switch(props.modal_type) {
            case 'Hank':
                actions.handleModalDisplay({ display: 'ArActivation', status: true });
                return;
            case 'Redirect':
                actions.handleModalDisplay({ display: 'RedirectPrompt', status: true });
                return;
            default:
                return;                
        }
    }
    
    return (
        <ModalBtnDesign
            _handleLaunchAR={_handleLaunchAR} 
            design={props.design}
        />
    );
}

const ModalBtnDesign = (props) => {
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    
    switch(props.design) {
        case 'normal':
            return (
                <div className={classes.button_container_default}>
                    <button onClick={(e) => props._handleLaunchAR(e)} className={classes.btn_from_modal}>
                        <img src={ARicon} alt="AR" className={classes.button_ar_default} />
                        <span className={classes.ar_text}>{dynamic_text_settings.mobile_ar_button.button_text}</span>
                    </button>
                </div>
            );
        case 'rotate_icon':
            return (
                <div className={classes.iconContainer}>
                    <button onClick={(e) => props._handleLaunchAR(e)}>
                        <img src={Rotate360} alt="AR" className={classes.button_ar_rotate} />
                    </button>
                </div>
            )
        case 'billboard':
            return (
                <div className={classes.button_container_billboard}>
                    <button onClick={(e) => props._handleLaunchAR(e)}>
                        <span>{dynamic_text_settings.mobile_ar_button.button_text}</span>
                        <img src={ARicon} alt="AR" className={classes.button_ar_icon_billboard} />
                    </button>
                </div>
            )
        default: 
            return (
                <div className={classes.button_container_default}>
                    <button onClick={(e) => props._handleLaunchAR(e)} className={classes.btn_from_modal}>
                        <img src={ARicon} alt="AR" className={classes.button_ar_default} />
                        <span className={classes.ar_text}>{dynamic_text_settings.mobile_ar_button.button_text}</span>
                    </button>
                </div>
            );
    }
}